@keyframes wbagent-row-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Theme-aware via the semantic text tokens; no separate dark-mode block. */
.wbagent-row-shimmer {
  background-image: linear-gradient(
    90deg,
    var(--wb-text-disabled) 0%,
    var(--wb-text-disabled) 40%,
    var(--wb-text-primary) 50%,
    var(--wb-text-disabled) 60%,
    var(--wb-text-disabled) 100%
  );
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: wbagent-row-shimmer 2.2s linear infinite;
}
